import ColumnFilter from '../../ColumnFilter';
import { useState } from 'react';
import { useDebouncedOnChange } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button } from 'antd';
import { useGroups } from '@/core/domain/operational/Groups/Groups.hooks';

interface Props {
  onChange(value: number): void;
  value?: number;
}

const SubGroupColumnFilter: React.FC<Props> = (props) => {
  const [search, setSearch] = useState('');
  const [value, setValue] = useState();

  const onSearch = useDebouncedOnChange(setSearch);

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } = useGroups(
    {
      active: true,
      search: search,
    },
  );

  const dataSource = flatInfiniteData(data);

  return (
    <ColumnFilter
      loading={isLoading}
      onSearch={onSearch}
      onChange={(value) => {
        props.onChange(value);
        setValue(value);
      }}
      value={props.value || value}
      dataSource={dataSource
        .map((item) =>
          item.subGroups.map((subGroup) => ({
            value: subGroup.id,
            label: subGroup.name,
          })),
        )
        .flat()}
      footer={
        hasNextPage && (
          <Button
            type="primary"
            block
            loading={isFetching}
            onClick={() => fetchNextPage()}
          >
            Carregar mais
          </Button>
        )
      }
    />
  );
};

export default SubGroupColumnFilter;
